/*
 * DebugResourceView  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IView, IViewInfo } from "../../../view/IView";
import { LayoutState } from "../../../ui/components/Layout/LayoutState";
import { DebugResourceViewLayoutConfig } from "./ResourceDebugViewLayout";
import { IEditor } from "../../../IEditor";
import { CommandsService } from "../../../commands/CommandsService";
import { ResourceService } from "../../../resources/ResourceService";
import { TEditorBlueprintResource } from "../../../resources/ResourceTypes";
import { IResourceDescription } from "@adapptio/lib-core";

/**
 * View parameters
 */
interface IDebugResourceViewParams {
	resourceId: string;
}

/**
 * Error Log View
 */
export class ResourceDebugView implements IView<IDebugResourceViewParams> {
	/** Deployment service */
	private commandsService: CommandsService;

	/** Resource service */
	private resourceService: ResourceService;

	/** Layout state */
	private layout: LayoutState;

	private resourceDescriptor: IResourceDescription;

	private resource: TEditorBlueprintResource;

	/**
	 * View constructor
	 *
	 * @param dc Dependency container
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	public constructor(private dc: IEditor) {
		this.commandsService = dc.get("commandsService");
		this.resourceService = dc.get("resourceService");

		this.layout = new LayoutState(DebugResourceViewLayoutConfig);
	}

	/**
	 * Initializes view
	 * @param params Params
	 */
	public async init(params: IDebugResourceViewParams): Promise<void> {
		this.resourceDescriptor = this.resourceService.getResourceDescriptorById(params.resourceId);
		this.resource = await this.resourceService.getBlueprintById(params.resourceId, {
			allowUnknownType: true
		});
		console.log({ resource: this.resource });
	}

	/**
	 * Disposes view
	 */
	public dispose(): void {
		this.layout.dispose();
	}

	/**
	 * Returns layout state
	 */
	public getLayout(): LayoutState {
		return this.layout;
	}

	public getResource(): TEditorBlueprintResource {
		return this.resource;
	}

	/**
	 * Returns view info
	 */
	public getViewInfo = (): IViewInfo => {
		return {
			label: this.resourceDescriptor?.name || "Unknown",
			icon: "mdi/help",
			canClose: true,
			isModified: false,
			renderWhenNotActive: true
		};
	};
}
